export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1F3617] text-white py-12"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="flex items-center gap-3">
              <span
                role="img"
                aria-label="Arvo"
                className="block h-14 w-14 rounded-full bg-[#F9F8F6] bg-no-repeat bg-center bg-contain"
                style={{
                  backgroundImage: "url('/screens/logo-cow.png')",
                }}
              />
              <span className="font-display text-2xl font-bold tracking-tight">
                arvo
              </span>
            </div>
            <p className="mt-4 text-sm text-white/70 max-w-sm leading-relaxed">
              Accurate livestock data capture — fast, simple, and built for the
              yard.
            </p>
          </div>

          <div>
            <p className="font-display font-bold text-sm uppercase tracking-wider text-[#F2C76A]">
              Explore
            </p>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li>
                <a href="#features" className="hover:text-white transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#how" className="hover:text-white transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-white transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#cta" className="hover:text-white transition-colors">
                  Request Demo
                </a>
              </li>
              <li>
                <a
                  href="/farm-it-forward"
                  data-testid="footer-golf-link"
                  className="hover:text-white transition-colors"
                >
                  Farm It Forward
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-display font-bold text-sm uppercase tracking-wider text-[#F2C76A]">
              Built for
            </p>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li>Dairy &amp; beef breeding operations</li>
              <li>Livestock contractors</li>
              <li>Service providers</li>
              <li>NZ livestock systems</li>
            </ul>
            <p className="mt-5 text-xs uppercase tracking-wider font-bold text-[#F2C76A]">
              Support
            </p>
            <a
              href="mailto:support@getarvo.co.nz"
              data-testid="footer-support-email"
              className="mt-2 inline-block text-sm text-white/90 hover:text-white underline-offset-4 hover:underline"
            >
              support@getarvo.co.nz
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Arvo. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a
              href="/privacy"
              data-testid="footer-privacy-link"
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="/support"
              data-testid="footer-support-link"
              className="hover:text-white transition-colors"
            >
              Support
            </a>
            <p>Built with farmers and service providers in mind.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
